import { FieldsEnum, FormsEnum } from 'app/shared/enums';
import {
  getQuotationIsFromRenewal,
  setDataOwnersChangedRenewal,
  setQuestionVisibility,
} from 'app/services/businessFunctionHelpers';

export function handleOnChangeDataOwnerRenewal(initialRun?: boolean) {
  const isFromRenewal = getQuotationIsFromRenewal();

  if (isFromRenewal && !initialRun) {
    setDataOwnersChangedRenewal({
      ownerName: 'owner',
      isChanged: true,
    });

    setQuestionVisibility({
      key: FieldsEnum.OwnerDriverLicenseYear,
      visible: true,
      formName: FormsEnum.CalculationForm,
    });

    setQuestionVisibility({
      key: FieldsEnum.OwnerNoDrivingLicense,
      visible: true,
      formName: FormsEnum.CalculationForm,
    });
  }
}
